export const EntryType = Object.freeze({Manual: 1, API: 2});